import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CalendarEventTitleFormatter, CalendarEvent } from 'angular-calendar';
import * as moment from 'moment';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { SafeHtmlUtils } from 'src/app/utils/safe-html.util';


@Injectable()
export class CustomEventTitleFormatter extends CalendarEventTitleFormatter {

  constructor(
    private sanitizer: DomSanitizer,
    private _strUtilsSrv: StringUtilsService
  ) {
    super();
  }

  public monthTooltip(event: CalendarEvent, title: string): string {
    return `${moment(event.start).format('kk:mm')} - ${moment(event.end).format('kk:mm')} ${event.meta && event.meta.patient ? 'avec ' + event.meta.patient.nom.toLocaleUpperCase() + ' ' + this._strUtilsSrv.uppercaseFirstCharString(event.meta.patient.prenom) : 'Sans patient'}`;
  }

  public weekTooltip(): string {
    return;
  }

  public dayTooltip(): string {
    return;
  }

  public day(event: CalendarEvent): any {
    return this.getEventTitle(event, 'day');
  }

  public week(event: CalendarEvent): any {
    return this.getEventTitle(event, 'week');
  }

  private getEventTitle(event: CalendarEvent, view: 'day' | 'week'): any {
    const statusLabel = SafeHtmlUtils.escapeHtml(event.meta?.status?.label || '');
    const statusClass = this.statusIconClass(event.meta?.status?.label);
    const statusIconHtml = `
      <span class="status-badge ${statusClass}"
        data-status-badge="1" title="${statusLabel}"></span>
    `;

    const isDay = view === 'day';
    const cssClass = isDay
        ? 'custom-event-patient multiline'
        : 'custom-event-patient';
    let str = "";
    if (event.meta.patient) {
      const patientName = SafeHtmlUtils.escapeHtml((event.meta.patient.nom || '') + ' ' + (event.meta.patient.prenom || ''));
      const patientBirth = SafeHtmlUtils.escapeHtml(event.meta.patient.dateNaissance || '');
      const desc = isDay ? SafeHtmlUtils.escapeHtml(this.toPlainText(event.meta?.description)) : '';

      str = `<span data-event-id="${SafeHtmlUtils.escapeHtml(event.meta.id)}" class="event-title-root ${cssClass}">
              <span class="event-title-line">
                ${statusIconHtml}
                <span class="event-title-main">${patientName} - (${patientBirth})</span>
              </span>
              ${desc ? `<span class="event-title-desc">${desc}</span>` : ''}
            </span>
          `;
    }

    else {
      const title = SafeHtmlUtils.escapeHtml(this.toPlainText(event.meta?.description) || event.title || 'Aucune information');

      str = `<span data-event-id="${SafeHtmlUtils.escapeHtml(event.meta.id)}" class="event-title-root ${cssClass}">
              <span class="event-title-line">
                ${statusIconHtml}
                <span class="event-title-desc">${title}</span>
              </span>
            </span>
          `;
    }
    return this.sanitizer.bypassSecurityTrustHtml(str);
  }

  private toPlainText(value: any): string {
    if (!value) return '';

    // cas Quill / HTML
    return value
      .toString()
      .replace(/<[^>]*>/g, ', ')
      .replace(/\r\n|\r|\n+/g, ', ')
      .replace(/\s+/g, ', ')
      .trim();
  }

  private normalizeStatusLabel(label?: string): string {
    return (label || '')
      .trim()
      .toLowerCase()
      .replace(/[’‘`´]/g, "'")
      .replace(/\u00A0/g, ' ')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private statusIconClass(label?: string): string {
    const key = this.normalizeStatusLabel(label);

    switch (key) {
      case 'annule': return 'st-cancelled';
      case 'deplace': return 'st-moved';
      case 'vu par le medecin': return 'st-seen';
      case 'en salle d attente': return 'st-waiting';
      case 'en retard': return 'st-late';
      case 'non honore': return 'st-no-show';
      default: return 'st-default';
    }
  }
}
